import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import FieldHorizontal from '@/components/FieldHorizontal/FieldHorizontal'
import Container from '@/components/Container/Container'

import { mapGetters } from 'vuex'

export default {
  name: 'NewCalibration',
  computed: {
    ...mapGetters({
      error: 'calibrationsError'
    })
  },
  data() {
    return {
      newCalibration: {
        id: null,
        sensorid: null,
        datetimeStartCalibration: null,
        datetimeEndCalibration: null,
        gain: null,
        offset: null,
        gaino2: null,
        offseto2: null
      }
    }
  },
  components: {
    FontAwesomeIcon,
    FieldHorizontal,
    Container
  },
  methods: {
    updateCalibration(key, value) {
      this.$data.newCalibration[key] = value || null
    },
    createCalibration() {
      const payload = this.newCalibration
      payload.datetimeStartCalibration = this.newCalibration.datetimeStartCalibration
        ? (new Date(this.newCalibration.datetimeStartCalibration).getTime() / 1000).toFixed(0)
        : null
      payload.datetimeEndCalibration = this.newCalibration.datetimeEndCalibration
        ? (new Date(this.newCalibration.datetimeEndCalibration).getTime() / 1000).toFixed(0)
        : null
      this.$store.dispatch('createCalibration', this.newCalibration).then(() => {
        this.$router.push('/calibrations')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/NewCalibration/script.js